import React from 'react';
import { motion } from 'framer-motion';
import { useLocation } from 'react-router-dom';
import { useEffect } from 'react';
import { useMountDebug } from '@/hooks/shared/useMountDebug';

interface ContentTransitionProps {
  children: React.ReactNode;
}

export const ContentTransition: React.FC<ContentTransitionProps> = ({ children }) => {
  const location = useLocation();
  useMountDebug('ContentTransition');

  useEffect(() => {
    console.info('[ContentTransition] route change', {
      pathname: location.pathname,
      search: location.search,
      key: location.key,
      hash: location.hash,
      timestamp: new Date().toISOString(),
    });
  }, [location.pathname, location.search, location.hash, location.key]);

  // Não usar key={location.pathname}: desmontar/remontar o motion.div a cada rota
  // pode causar conflito com a reconciliação do React (insertBefore em nó inválido).
  // Mantemos o mesmo nó e apenas trocamos o conteúdo (children).
  return (
    <div className="h-full w-full relative" style={{ isolation: 'isolate' }}>
      <motion.div
        initial={false}
        animate={{ opacity: 1, x: 0 }}
        transition={{
          duration: 0.12,
          ease: [0.4, 0.0, 0.2, 1]
        }}
        className="h-full w-full absolute inset-0"
      >
        {children}
      </motion.div>
    </div>
  );
};
